import React from "react";
import Card from "../../../models/Card";
import CardFlip from "../../../components/cardFlip/component";
import { Trans } from "react-i18next";
import "./cardNavList.css";

interface Props { cards: Card[]; currentBookKey: string; t: (k: string) => string; }
interface State { selected: string | null; showMastered: boolean; }

class CardNavList extends React.Component<Props, State> {
  constructor(p: Props) { super(p); this.state = { selected: null, showMastered: false }; }
  componentDidUpdate(prev: Props) { if (prev.currentBookKey !== this.props.currentBookKey) this.setState({ selected: null }); }

  render() {
    const filtered = this.props.cards.filter((c) => c.bookKey === this.props.currentBookKey);
    const display = this.state.showMastered ? filtered.filter((c) => c.mastered) : filtered.filter((c) => !c.mastered);
    const handleUpdate = () => this.forceUpdate();

    if (filtered.length === 0) return <div className="cnempty"><Trans>No cards yet</Trans></div>;

    return (
      <div className="cnl">
        <div className="cntabs">
          <span className={`cntab ${!this.state.showMastered ? "active" : ""}`} onClick={() => this.setState({ showMastered: false })}><Trans>In Review</Trans><span className="cnc">{filtered.filter((c) => !c.mastered).length}</span></span>
          <span className={`cntab ${this.state.showMastered ? "active" : ""}`} onClick={() => this.setState({ showMastered: true })}><Trans>Mastered</Trans><span className="cnc">{filtered.filter((c) => c.mastered).length}</span></span>
        </div>
        <div className="cnitems">
          {display.map((c) => (
            <div key={c.key} className="cnw">
              {this.state.selected === c.key ? <CardFlip card={c} t={this.props.t} onUpdate={handleUpdate} /> : (
                <div className="cnp" onClick={() => this.setState({ selected: c.key })}>
                  <div className="cnpt">{c.originalText.substring(0, 120)}{c.originalText.length > 120 ? "..." : ""}</div>
                  <div className="cnpm"><span>{c.chapter || "Unknown"}</span><span>{c.mastered ? "✅" : "📝"}</span></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default CardNavList;
